import { HStack } from '@chakra-ui/react';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { SuggestionBackButton } from '~/components/ui/tabs/components/BackButton';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';

const ROOMS_RANGES = [
  { label: '1 rum', min: 1, max: 1 },
  { label: '2 rum', min: 2, max: 2 },
  { label: '3 rum', min: 3, max: 3 },
  { label: '4 rum', min: 4, max: 4 },
  { label: '5 rum', min: 5, max: 5 },
  { label: '6+ rum', min: 6, max: null },
];

export const RoomsRangeTabContent = () => {
  const filters = useHomesStore((state) => state.filters);
  const { rooms_min, rooms_max } = filters || {};
  const { performSearch } = useFilters();

  const isActive = (range: { min: number; max: number | null }) => {
    return rooms_min === range.min && rooms_max === range.max;
  };

  const onSelectRange = (range: { min: number; max: number | null }) => {
    if (isActive(range)) {
      performSearch({
        filters: { rooms_min: undefined, rooms_max: undefined },
      });
    } else {
      performSearch({
        filters: {
          rooms_min: range.min || undefined,
          rooms_max: range.max || undefined,
        },
      });
    }
  };

  return (
    <HStack mb={1} alignItems="center" overflowX="hidden">
      <SuggestionBackButton filterKeysToRemove={['categories']} />
      <SuggestionsButtonList>
        {ROOMS_RANGES.map((range, index) => (
          <SuggestionsButton
            key={index}
            label={range.label}
            isActive={isActive(range)}
            onClick={() => onSelectRange(range)}
          />
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
};
